<template>
    <label class="switch">
        <input type="checkbox" v-model="state" :checked="state">
        <span class="slider round"></span>
    </label>
</template>

<script>
    export default {
        name: "MJSliderButtonAndroid",
        data() {
            return {
                state: false
            }
        },
        watch: {
            state(value) {
                this.$emit("input", value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/color_palette";

    $knob-size: 20px;
    $knob-position-bottom: -2px;
    $knob-position-left: -2px;
    $input-height: 14px;
    $input-width: 34px;
    .switch {
        position: relative;
        display: inline-block;
        width: $input-width;
        height: $input-height;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: black("30");
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: $knob-size;
        width: $knob-size;
        left: $knob-position-left;
        bottom: $knob-position-bottom;
        background-color: rgb(242, 242, 242);
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12),
        0 2px 2px 0 rgba(0, 0, 0, 0.24);
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: blue("100");
    }

    input:checked + .slider:before {
        -webkit-transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
        -ms-transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
        transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: $knob-size;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>